import qs from 'qs'

import { HTTP } from './helpers/http'

export default {
  getAll(args = {}) {
    const {
      organizationId,
      relations = [],
      filters = {},
      sort = {},
      limit,
      skip,
      page,
      routineDefinition,
    } = args
    const params = {
      filters,
      relations,
      sort,
      skip,
      limit,
      routineDefinition,
      page,
    }

    return HTTP.get(`/api/v1/organizations/${organizationId}/findings`, {
      params,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    })
  },

  getById(args = {}) {
    const { organizationId, findingId, relations = [] } = args

    const params = {
      relations,
    }

    return HTTP.get(
      `/api/v1/organizations/${organizationId}/findings/${findingId}`,
      {
        params,
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      }
    )
  },

  update(args = {}) {
    const { organizationId, findingId, data } = args
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/findings/${findingId}`,
      data
    )
  },

  create(args = {}) {
    const { organizationId, data } = args
    return HTTP.post(`/api/v1/organizations/${organizationId}/findings/`, data)
  },

  delete(organizationId, findingId) {
    const url = `/api/v1/organizations/${organizationId}/findings/${findingId}`
    return HTTP.delete(url)
  },

  bulkDelete(args = {}) {
    const { organizationId, findingsIds } = args
    const data = {
      operation: 'delete',
      ids: findingsIds,
    }
    const url = `/api/v1/organizations/${organizationId}/findings/bulk`
    return HTTP.post(url, data)
  },

  bulkEditDueDate(args = {}) {
    const { organizationId, findingsIds, dueDate } = args
    const data = {
      operation: 'patch',
      ids: findingsIds,
      data: {
        dueDate: dueDate,
      },
    }
    const url = `/api/v1/organizations/${organizationId}/findings/bulk`
    return HTTP.post(url, data)
  },

  bulkAddAssignees(args = {}) {
    const { organizationId, findingsIds, assignees } = args
    const data = {
      operation: 'patch',
      ids: findingsIds,
      data: {
        assignees,
      },
    }
    const url = `/api/v1/organizations/${organizationId}/findings/bulk`
    return HTTP.post(url, data)
  },
}
